var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart',{attrs:{"chartdata-sets":_vm.chartData.datasets,"chartdata-labels":_vm.chartData.labels,"max-ticks":_vm.chartDataMaxTicks,"x-stacked":false,"y-stacked":false}})}
var staticRenderFns = []

export { render, staticRenderFns }